import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentDate: new Date(),
    addressSelect:'',
  },
  mutations: {
    updateCurrentDate(state, val) {
      state.currentDate = val;
    },
    updateAddress(state,val){
      console.log(222222222)
      console.log(val)
      state.addressSelect = val;
    },
  },
  actions: {
  },
  modules: {
    auth,
  },
});
